import { render, staticRenderFns } from "./GeneralSetting.vue?vue&type=template&id=122944bc&scoped=true"
import script from "./GeneralSetting.vue?vue&type=script&lang=ts"
export * from "./GeneralSetting.vue?vue&type=script&lang=ts"
import style0 from "./GeneralSetting.vue?vue&type=style&index=0&id=122944bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122944bc",
  null
  
)

export default component.exports